import React from 'react'

const LoaderComponent = () =>
{
    return (
        <div style={{ display: 'grid', placeItems: 'center', padding: '50px', fontSize: '34px' }}>
            Loading....
        </div>
    )
}

export default LoaderComponent
